import Customers from '@/models/loyaltyPanel/Customers';
const getDefaultState = () => ({
  tabDialog: false,
  mergeDialog: false,
  customers: [],
  storeCustomers: [],
  customersDetails: [],
  customerResponse: {
    response: false,
    status: 'success',
    message: '',
    error: false,
  },
  formLoading: false,
  newCardIsValid: null,
  newCardLoading: false,
  customersTableLoading: false,
  customerData: new Customers(),
  mergeDialogMobile: null,
  transDialogUserAccId: null,
  transDialogUserId: null,
  successCode: false,
  companyStores: [],
  userTransactions: [],
  companyStoresLoading: false,
  userTransItemsLength: 1,
  storesTotalPages: null,
  visibleColumns: (localStorage.getItem('visibleColumns') &&
    JSON.parse(localStorage.getItem('visibleColumns'))) || [
    {
      column: 'user_account_id',
      isVisible: true,
    },
    {
      column: 'card_number',
      isVisible: true,
    },
    {
      column: 'mobile',
      isVisible: true,
    },
    {
      column: 'email',
      isVisible: true,
    },
    {
      column: 'first_name',
      isVisible: true,
    },
    {
      column: 'last_name',
      isVisible: true,
    },
    {
      column: 'total_transactions',
      isVisible: true,
    },
    {
      column: 'redeemed_points',
      isVisible: true,
    },
    {
      column: 'current_balance',
      isVisible: true,
    },
    {
      column: 'total_price',
      isVisible: true,
    },
    // {
    //     column:"user_id",
    //     isVisible: false
    // },
    {
      column: 'actions',
      isVisible: true,
    },
  ],
  attributes: [],
  attribute: {},
  filtersData: {
    child_id: null,
    first_transaction_store_id: null,
    registration_store_id: null,
    country_id: null,
    gender: null,
    minimum_age: null,
    maximum_age: null,
    county_id: null,
    marketing: null,
    sms: null,
    viber: null,
    push: null,
    mail: null,
    minimum_total_transactions: null,
    maximum_total_transactions: null,
    minimum_total_redemptions: null,
    maximum_total_redemptions: null,
    minimum_total_amount: null,
    maximum_total_amount: null,
    minimum_current_balance: null,
    maximum_current_balance: null,
    birth_date: null,
  },
  userPoints: [],
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  getters: {
    formStores: (state) => state.formStores,
    countryCodes: (state) => state.countryCodes,
    customersDetails: (state) => state.customersDetails,
    customers: (state) => state.customers,
    storeCustomers: (state) => state.storeCustomers,
    customerResponse: (state) => state.customerResponse,
    newCardIsValid: (state) => state.newCardIsValid,
    newCardLoading: (state) => state.newCardLoading,
    customersTableLoading: (state) => state.customersTableLoading,
    formLoading: (state) => state.formLoading,
    mergeDialogMobile: (state) => state.mergeDialogMobile,
    transDialogUserAccId: (state) => state.transDialogUserAccId,
    transDialogUserId: (state) => state.transDialogUserId,
    userTransactions: (state) => state.userTransactions,
    userTransItemsLength: (state) => state.userTransItemsLength,
  },

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setMode(state, payload) {
      state.mode = payload;
    },
    setCustomerDialog(state, payload) {
      state.customerDialog = payload;
    },
    setUserTransactions(state, payload) {
      state.userTransactions = payload;
    },
    setTabDialog(state, payload) {
      state.tabDialog = payload;
    },
    setUserTransItemsLength(state, payload) {
      state.userTransItemsLength = payload;
    },
    setCustomers: (state, payload) => {
      state.customers = payload;
    },
    setStoreCustomers: (state, payload) => {
      state.storeCustomers = payload;
    },
    setCustomerData: (state, payload) => {
      state.customerData = new Customers(payload);
    },
    setMergeDialogMobile: (state, payload) => {
      state.mergeDialogMobile = payload;
    },
    setTransDialogUserAccId: (state, payload) => {
      state.transDialogUserAccId = payload;
    },
    setTransDialogUserId: (state, payload) => {
      state.transDialogUserId = payload;
    },
    setCustomerDialogMode(state, payload) {
      state.customerDialogMode = payload;
    },
    setShowCustomerDialog(state, payload) {
      state.customerDialog = payload;
    },
    setFormStores(state, payload) {
      state.formStores = payload;
    },
    setCountryCodes(state, payload) {
      state.countryCodes = payload;
    },
    setCustomersDetails(state, payload) {
      state.customersDetails = payload;
    },
    setFormLoading(state, payload) {
      state.formLoading = payload;
    },
    setCustomerResponse(state, payload) {
      state.customerResponse = payload;
    },
    setNewCardIsValid(state, payload) {
      state.newCardIsValid = payload;
    },
    setNewCardLoading(state, payload) {
      state.newCardLoading = payload;
    },
    setCustomersTableLoading(state, payload) {
      state.customersTableLoading = payload;
    },
    setSuccessCode(state, payload) {
      state.successCode = payload;
    },
    setCompanyStores(state, payload) {
      state.companyStores = payload;
    },
    setCompanyStoresLoading(state, payload) {
      state.companyStoresLoading = payload;
    },
    setStoresTotalPages(state, payload) {
      state.storesTotalPages = payload;
    },
    setMergeDialog(state, payload) {
      state.mergeDialog = payload;
    },
    setVisibleColumns(state, payload) {
      state.visibleColumns = payload;
      localStorage.setItem('visibleColumns', JSON.stringify(payload));
    },
    setAttributes(state, payload) {
      state.attributes = payload;
    },
    setAttribute(state, payload) {
      state.attribute = payload;
    },
    setFiltersData(state, payload) {
      state.filtersData = { ...state.filtersData, ...payload };
    },
    setUserPoints(state, payload) {
      state.userPoints = payload;
    },
    updateCustomerData(state, updatedCustomer) {
      const index = state.customers.findIndex(
        (c) => c.user_account_id === updatedCustomer.user_account_id
      );
      if (index !== -1) {
        state.customers.splice(index, 1, updatedCustomer);
      }
    },
  },

  actions: {
    async loadCustomers({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });
        let data;
        let filter = '';
        Object.keys(body.filters).forEach((key) => {
          if (body.filters[key] !== null && body.filters[key] !== undefined) {
            filter += '&' + key + '=' + body.filters[key];
          }
        });
        // if (!body.itab) {
        data = await Customers.get(body.query, filter);
        const customers = data.data.data.data;
        customers.map((item) => {
          item.points_balance = item.points_balance ? item.points_balance : '0';
          item.redeemed_points = item.redeemed_points ? item.redeemed_points : '0';
          item.total_amount = item.total_amount ? item.total_amount : '0';
          item.total_transactions = item.total_transactions ? item.total_transactions : '0';
        });
        commit('setCustomers', customers);

        const pagination = data && data.data && data.data.data.pagination;
        if (pagination) {
          commit('setServerItemsLength', pagination.total, {
            root: true,
          });

          commit('setServerPagination', pagination, {
            root: true,
          });
        }

        commit('setLoading', false, { root: true });
      } catch (ex) {
        console.error(ex);
        commit('setLoading', false, { root: true });
      }
    },

    async getCustomerProfile({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Customers.getCustomerProfile(body.id);
        commit('setCustomerData', data.data);
        if (body.mode == 'update') {
          commit('setDialog', true, { root: true });
        }
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async createNewCustomer({ commit, state, dispatch }) {
      try {
        commit('setLoading', true, { root: true });
        commit('setFormLoading', true);
        commit('setSuccessCode', false);
        let customerDetails = state.customerData;
        delete customerDetails.card_numbers;

        let res = await Customers.create(customerDetails);

        if (res.code == 200) {
          commit('setSuccessCode', true);
        }

        commit('setCustomerData', new Customers());
        commit('setCustomerResponse', {
          response: true,
          status: res.data.status,
          message: res.data.message.replace('_', ' '),
          error: false,
        });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: res.data.message.replace('_', ' '),
          },

          { root: true }
        );
        commit('setErrorMessage', '', { root: true });
        dispatch('loadCustomers', {
          query: '?page=1',
          filters: {},
        });
        setTimeout(() => {
          commit('setNewCardIsValid', null);
          commit('setCustomerResponse', {
            response: false,
            status: 'success',
            message: '',
            error: false,
          });
        }, 3000);
        commit('setDialog', false, { root: true });
        commit('setFormLoading', false);
        commit('setLoading', false, { root: true });
        return res.data;
      } catch (ex) {
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data.message,
          },

          { root: true }
        );
        commit('setLoading', false, { root: true });
        commit('setFormLoading', false);
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
      }
    },

    async loadCardStatus({ commit }, cardNumber) {
      try {
        if (!cardNumber || '' + cardNumber.length < 4 || '' + cardNumber.length > 10) {
          return commit('setNewCardIsValid', null);
        }
        commit('setNewCardLoading', true);
        let res = await Customers.cardSearch({
          card_number: cardNumber,
        });

        if (res.data.status === 'success' && res.data.data) {
          commit('setNewCardIsValid', true);
        } else {
          commit('setNewCardIsValid', null);
        }
        commit('setNewCardLoading', false);
      } catch (ex) {
        if (ex.response.data.error && ex.response.data.error_type === 'entity_error') {
          commit('setNewCardIsValid', false);
        } else {
          commit('setNewCardIsValid', null);
        }
        commit('setNewCardLoading', false);
      }
    },

    async loadCustomerDetails({ commit, getters }, id) {
      try {
        commit('setLoading', true, { root: true });
        commit('setFormLoading', true);
        let res = await Customers.customerDetails(id);

        if (res.data.status === 'success' && res.data.data) {
          commit('setCustomersDetails', [...getters.customersDetails, res.data.data]);
        }

        commit('setLoading', false, { root: true });
        commit('setFormLoading', false);
      } catch (ex) {
        console.log(ex);
        commit('setLoading', false, { root: true });
        commit('setFormLoading', false);
      }
    },

    async loadUserTransactions({ commit, getters }, q) {
      try {
        commit('setLoading', true, { root: true });
        commit('setFormLoading', true);
        let filter = q.query;
        Object.keys(q.filters).map((key) => {
          if (q.filters[key]) {
            filter += '&' + key + '=' + q.filters[key];
          }
        });
        let res = await Customers.getTransactions(getters.transDialogUserAccId, filter);

        if (res.data.status === 'success' && res.data.data) {
          commit('setUserTransactions', res.data.data.transactions);
          let pagination = res.data.data.pagination;
          if (pagination) {
            commit('setUserTransItemsLength', pagination.total);
          }
        }

        commit('setLoading', false, { root: true });
        commit('setFormLoading', false);
      } catch (ex) {
        console.log(ex);
        commit('setLoading', false, { root: true });
        commit('setFormLoading', false);
      }
    },

    async updateCustomer({ commit, state, getters, dispatch }) {
      try {
        commit('setLoading', true, { root: true });
        commit('setFormLoading', true);
        delete state.customerData.card_numbers;
        delete state.customerData.card_number;

        let res = await Customers.customerUpdate(state.customerData);

        if (res.data.status === 'success' && res.data.data) {
          commit(
            'setCustomersDetails',
            getters.customersDetails.filter((c) =>
              c.user_account_id === state.customerData.user_account_id ? res.data.data : c
            )
          );
          commit('setCustomerResponse', {
            response: true,
            status: res.data.status,
            message: res.data.message.replace('_', ' '),
            error: false,
          });
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: res.data.message.replace('_', ' '),
            },

            { root: true }
          );
          dispatch('loadCustomers', {
            query: '?page=1',
            filters: {},
          });
          setTimeout(() => {
            commit('setCustomerResponse', {
              response: false,
              status: 'success',
              message: '',
              error: false,
            });
          }, 3000);
        }
        commit('setErrorMessage', '', { root: true });
        commit('setDialog', false, { root: true });
        commit('setLoading', false, { root: true });
        commit('setFormLoading', false);
        return res.data;
      } catch (ex) {
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data.message,
          },

          { root: true }
        );
        commit('setLoading', false, { root: true });
        commit('setFormLoading', false);
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
      }
    },

    async mergeUsers({ commit, dispatch }, mobiles) {
      try {
        // ids.code = '2u95k74pjuqc6wpq';

        commit('setLoading', true, { root: true });

        let res = await Customers.mergeUsers(mobiles);
        commit('setLoading', false, { root: true });
        return res;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || ex,
          },

          { root: true }
        );
      }
    },

    async loadStores({ commit, state }, body) {
      try {
        commit('setCompanyStoresLoading', true);

        let { data } = await Customers.getStores(body.query);
        if (body.page == 1) {
          commit('setCompanyStores', data.data.data);
        } else {
          const stores = state.companyStores;
          data.data.data.map((item) => {
            stores.push(item);
          });
          commit('setCompanyStores', stores);
        }

        commit('setServerItemsPerPage', data.data.pagination.items_per_page, {
          root: true,
        });
        commit('setStoresTotalPages', data.data.pagination.total_pages);

        commit('setCompanyStoresLoading', false);
      } catch (ex) {
        commit('setCompanyStoresLoading', false);
      }
    },

    async addNewCardNumber({ commit, dispatch }, body) {
      try {
        commit('setLoading', true, { root: true });

        await Customers.addNewCardNumber(body);

        dispatch('loadCustomers', {
          query: '?page=1',
          filters: {},
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || ex,
          },

          { root: true }
        );
      }
    },

    async updateMobile({ commit, dispatch }, body) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await Customers.updateMobile(body);

        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || ex,
          },

          { root: true }
        );
      }
    },

    async removePoints({ commit, dispatch }, id) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await Customers.removePoints(id);

        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || ex,
          },

          { root: true }
        );
      }
    },

    async detachCard({ commit, dispatch }, payload) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await Customers.detachCard(payload.user_account_id, {
          card_number: payload.card_number,
        });

        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || ex,
          },

          { root: true }
        );
      }
    },
    async importCustomers({ commit, dispatch }, file) {
      try {
        commit('setLoading', true, { root: true });

        let payload = new FormData();
        payload.append('users', file);

        let { data } = await Customers.importCustomers(payload);

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || ex,
          },

          { root: true }
        );
      }
    },

    async getAttributes({ commit, state }, query) {
      try {
        commit('setLoading', true, { root: true });
        query = query || '';
        let { data } = await Customers.getAttributes(query);
        commit('setAttributes', data.data);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setCompanyStoresLoading', false);
      }
    },

    async createAttribute({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });
        // body.options= body.options || []
        let { data } = await Customers.createAttribute(body);
        let success = data.status == 'success';
        if (success) {
          commit('setAttributes', [...state.attributes, data.data]);
        }
        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setCompanyStoresLoading', false);
        commit('setLoading', false, { root: true });
      }
    },

    async updateAttribute({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });
        let id = body.user_account_attribute_definition_id;
        body.user_account_attribute_definition_id = undefined;
        body.user_account_attribute_definition_value_ids = undefined;
        body.user_account_attribute_definition_values = undefined;
        body.store_id = undefined;
        body.type = undefined;
        body.used = undefined;
        let { data } = await Customers.updateAttribute(id, body);
        let success = data.status == 'success';
        if (success) {
          let attributeIndex = state.attributes.findIndex(
            (x) => x.user_account_attribute_definition_id != id
          );
          state.attributes[attributeIndex] = data.data;
        }

        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.log(ex);
        commit('setCompanyStoresLoading', false);
        return ex.response?.data;
      }
    },

    async deleteAttribute({ commit, state }, id) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await Customers.deleteAttribute(id);
        let success = data.status == 'success';
        if (success) {
          commit(
            'setAttributes',
            state.attributes.filter((e) => e.user_account_attribute_definition_id != id)
          );
        }

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setCompanyStoresLoading', false);
      }
    },

    async deleteCustomer({ commit, state }, id) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await Customers.deleteCustomer(id);
        let success = data.status == 'success';
        if (success) {
          commit(
            'setCustomers',
            state.customers.filter((e) => e.user_account_id != id)
          );
        }

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setCompanyStoresLoading', false);
      }
    },

    async doAdjustPoints({ commit, state }, payload) {
      try {
        commit('setLoading', true, { root: true });
        let id = payload.user_account_id;
        delete payload.user_account_id;

        let { data } = await Customers.doAdjustPoints(id, payload);
        let success = data.status == 'success';
        if (success) {
          let customer = state.customers.find((e) => e.user_account_id == id);
          if (customer) {
            customer.current_balance = data.data.user_current_balance;
          }
        }

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setCompanyStoresLoading', false);
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data.message || 'error',
          },

          { root: true }
        );
      }
    },
    async redeemCoupons({ commit }, payload) {
      try {
        commit('setLoading', true, { root: true });
        let userAccountId = payload.user_account_id;
        delete payload.user_account_id;
        const { data } = await Customers.redeemCoupons(userAccountId, payload);
        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || 'Error',
          },
          { root: true }
        );
      }
    },

    async fetchUserPoints({ commit }, user_account_id) {
      try {
        const res = await Customers.fetchUserPoints(user_account_id);
        if (res && res.data) {
          commit('setUserPoints', res.data.data || []);
        }
      } catch (error) {
        console.error('Error fetching user points:', error);
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: 'Error Fetching Points',
          },
          { root: true }
        );
      }
    },

    async updateCustomerAttributes(
      { commit, state },
      { user_account_id, attribute_id, value_id, value }
    ) {
      try {
        commit('setLoading', true, { root: true });

        const body = {};
        if (value_id && Array.isArray(value_id)) {
          body.user_account_attribute_definition_value_ids = value_id;
        } else {
          body.value = value;
          body.user_account_attribute_definition_value_id = value_id;
        }

        const { data } = await Customers.updateCustomerAttribute(
          user_account_id,
          attribute_id,
          body
        );

        commit('setLoading', false, { root: true });
        return data;
      } catch (error) {
        commit('setLoading', false, { root: true });
        console.error('Error updating customer attribute:', error);
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: 'Error Updating Customer Attribute',
          },
          { root: true }
        );
        throw error;
      }
    },

    async deleteCustomerAttribute({ commit, state }, { user_account_id, attribute_id, value_id }) {
      try {
        commit('setLoading', true, { root: true });

        const res = await Customers.deleteCustomerAttribute(
          user_account_id,
          attribute_id,
          value_id
        );

        commit('setLoading', false, { root: true });
        return res.data;
      } catch (error) {
        commit('setLoading', false, { root: true });
        console.error('Error deleting customer attribute:', error);
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: 'Error Deleting Customer Attribute',
          },
          { root: true }
        );
        throw error;
      }
    },
  },
};
